import React__default from 'react';

/**
 * Render the button elements in the calendar.
 *
 * @private
 * @deprecated Use `PreviousMonthButton` or `@link NextMonthButton` instead.
 */
function Button(props) {
    return React__default.createElement("button", { ...props });
}

export { Button };
